import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="returns">
      <Header />

      <main className="returns-main">
        <div className="page-hero">
          <h1>Returns & Exchanges</h1>
          <p>Not quite right? Let's fix that.</p>
        </div>

        <div className="returns-content">
          <section className="policy-section">
            <h2>Our Return Policy</h2>
            <p>
              We want you to be completely satisfied with your Parkhaven
              purchase. If you are not entirely happy, we gladly accept returns
              of unworn, unwashed, or defective merchandise within{" "}
              <strong>60 days</strong> of purchase.
            </p>

            <div className="policy-grid">
              <div className="policy-card">
                <h3>Online Purchases</h3>
                <p>
                  Returns are free when you use our prepaid return label. A flat
                  $8 fee will be deducted from your refund for the return
                  shipping.
                </p>
                <ul>
                  <li>Must include original tags and packaging</li>
                  <li>Refunds are issued to the original form of payment</li>
                  <li>Processing takes 7-10 business days after receipt</li>
                </ul>
              </div>

              <div className="policy-card">
                <h3>Exchanges</h3>
                <p>
                  Need a different size or color? Exchanges are completely free!
                  We'll ship your new item as soon as your return is scanned by
                  the carrier.
                </p>
                <ul>
                  <li>Instant exchanges available online</li>
                  <li>Subject to inventory availability</li>
                  <li>Price matches guaranteed on exchanges</li>
                </ul>
              </div>
            </div>

            <div className="final-sale-notice">
              <h3>Final Sale Items</h3>
              <p>
                Items marked as "Final Sale" cannot be returned or exchanged.
                This includes select clearance items, underwear, and face masks
                for hygiene reasons.
              </p>
            </div>
          </section>

          <section className="faq-section">
            <h2>Common Questions</h2>
            <div className="faq-item">
              <h3>Can I return an online order to a Parkhaven store?</h3>
              <p>
                Yes! You can return items purchased on www.parkhaven.cloud to
                any of our retail stores. Please bring your packing slip or
                order confirmation email.
              </p>
            </div>
            <div className="faq-item">
              <h3>What if I received a defective item?</h3>
              <p>
                We stand behind the quality of our products. If you receive a
                defective item, please{" "}
                <Link onClick={toTop} to="/contact">
                  contact our customer care team
                </Link>{" "}
                immediately so we can make it right.
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
